import apiServices from '../../ApiServices/request-handler';
import { requestHandler } from '../../utils/functions';
import { setToken } from '../../utils/utils';
import { setAuthLoading, setConfigurationSettingsLoading } from '../slices/authSlice';
import { setConfigurationSettingsData, setUserData } from '../slices/contentSlice';
import { createAction } from '@reduxjs/toolkit';

export const logoutUser = (onDone, isArabic) => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        setLoading: setAuthLoading,
        apiService: apiServices.logout,
        onDone: () => {
          dispatch(setUserData(null));
          setToken("");
          onDone && onDone();
          dispatch(logoutAction());
          window.location.href = `${process.env.REACT_APP_OPEN_ACCOUNT_LINK}${isArabic ? 'ar' : 'en'}`;
        },
      })
    );
  };
};

// Configuration Settings

export const getConfigurationSettings = () => {
  return async (dispatch) => {
    dispatch(
      requestHandler({
        apiService: apiServices.getConfigurationSettings,
        setLoading: setConfigurationSettingsLoading,
        setData: setConfigurationSettingsData,
      })
    );
  };
};

export const logoutAction = createAction('auth/logout');
